export const sendEvent = (action: string, params?: Record<string, unknown>) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", action, {
      ...params,
      debug_mode: import.meta.env.MODE === "development", // Only logs in dev
    });
  } else {
    console.debug("[GA] gtag is not available yet:", action, params);
  }
};

// Optional: declare global `gtag` for TypeScript autocomplete and safety
declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}
